import { newServer } from 'constants/constants';

export const updateEnroll = async (user: any, bodyData: any) => {
  const response = await fetch(`${newServer}requests`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${user?.token}`,
    },
    body: JSON.stringify(bodyData),
  });

  const responseText = await response.text();
  let data: any = responseText;

  if (responseText) {
    try {
      data = JSON.parse(responseText);
    } catch (_error) {
      // Some successful legacy endpoints return plain text (for example, "OK").
    }
  }

  if (!response.ok) {
    const message =
      data?.message || data?.info?.message || responseText || `Request failed (${response.status})`;
    throw new Error(message);
  }

  return data;
};
